export const NotificationTypes = {
	Success: "success",
	Alert: "warning",
	CriticalAlert: "error",
	Info: "info",
	Reminder: "warning"
}